<template>
  <div id="app">
    <v-app>
        <v-container fluid class="custom">
          <v-layout>
          <v-flex>
              <template v-if="currentUser">
                <headerbar app :showMenu="show"></headerbar>
              </template>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <main>
               <router-view></router-view> 
              </main>
            </v-flex>
           </v-layout>
         </v-container>
    </v-app>
  </div>
</template>

<script>
import HeaderBar from './components/HeaderBar.vue'
import MainContent from './components/MainContent.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'app',
  data: function () {
    return {
      title: 'Display Case Manager',
      menuItems: ['Metro Blue Line', 'Metro Red Line', 'Metro Green Line', 'Metro Gold Line', 'Metro Purple Line', 'Metro Red Line'],
      drawer: null,
      show: false,
      right: null
    }
  },
  computed: {
    ...mapGetters({currentUser: 'currentUser'})
  },
  created () {
    this.checkLogin()
  },
  updated () {
    this.checkLogin()
  },
  methods: {
    checkLogin () {
      if (this.$route.path === '/signup') {
        this.$router.push('/signup')
      } else if (this.$route.path === '/resetpassword') {
        this.$router.push('/resetpassword')
      } else {
        if (!this.currentUser && this.$route.path !== '/') {
          this.$router.push('/?redirect=' + this.$route.path)
        }
      }
    }
  },
  components: {
    headerbar: HeaderBar,
    MainContent: MainContent
  }
}
</script>

<style>
.custom {
  background-color: white;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
@media only screen and (min-width: 992px) {
  body {
    min-height: 1500px;
    padding-top: 25px;
  }
}
@media only screen and (min-width: 600px) {
  #app {
    margin:0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue